<template>
    <v-dialog v-model="dialog" width="480" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }">
            <v-card-title> {{ title }} <v-spacer /> <v-icon @click="dialog = false">mdi-close</v-icon> </v-card-title>
            <v-card-text class="py-0">
                <v-row class="mx-n2 py-2">
                    <v-col cols="12" class="pa-2">
                        <autocomplete-user v-model="form._user" label="신청자" v-bind="{ ...attrs_input, loading, disabled: !isCreate }" :params="params_autocompleteUser" ref="autocomplete-user" />
                    </v-col>
                    <v-col cols="12" class="px-2 py-0">
                        <v-rrn-field v-model="form.residentRegistrationNumber" label="주민등록번호" class="mx-n2" class__col="pa-2" v-bind="{ ...attrs_input, loading, readonly: !isCreate }" />
                    </v-col>
                    <v-col cols="12" class="px-2 py-0">
                        <v-bank-field v-model="form.bank" v-bind="{ ...attrs_input, loading, readonly: !isCreate }" class="mx-n2" class__row="my-n2" class__col="pa-2" showsLabel />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <template v-if="mode == 'form'">
                    <v-col class="py-0">
                        <v-switch v-model="form.isActive" dense v-bind="attrs_switch">
                            <span slot="label" class="subtitle-2"> {{ form.isActive ? "활성화" : "비활성화" }} </span>
                        </v-switch>
                    </v-col>
                    <v-btn text color="primary" @click="save">저장</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_switch, INQUIRY_TYPES, USER_TYPES } from "@/assets/variables";

import VRrnField from "@/components/plugins/vuetify/v-rrn-field.vue";
import AutocompleteUser from "@/components/dumb/autocomplete-user.vue";
import VBankField from "@/components/plugins/vuetify/v-bank-field.vue";

const initInquiry = () => ({
    type: INQUIRY_TYPES.PROMOTER_APPROVAL.value,

    _user: null,

    inquiry: null,
    isActive: false,
});

const params_autocompleteUser = {
    type: [USER_TYPES.CONSUMER.value, USER_TYPES.PROMOTER.value],
};

export default {
    components: {
        VRrnField,
        AutocompleteUser,
        VBankField,
    },
    props: {
        _id: { type: String, default: null },
        mode: { type: String, default: "view" },
    },
    data: () => ({
        form: initInquiry(),

        dialog: false,
        loading: false,

        attrs_input,
        attrs_switch,
        params_autocompleteUser,
    }),
    computed: {
        isCreate() {
            return !this._id;
        },
        title() {
            let title = "정회원 전환요청";
            if (this.mode == "view") title += " 열람";
            else if (this.mode == "form") title += this.isCreate ? " 생성" : " 수정";
            return title;
        },
    },
    watch: {
        dialog() {
            if (this.dialog) this.init();
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                if (this.isCreate) this.form = initInquiry();
                else {
                    let { _id } = this;
                    this.form = (await api.console.inquiries.get({ _id }))?.inquiry;
                    this.$emit("input", { ...this.form });
                }
                this.$refs["autocomplete-user"]?.init?.();
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },
        validates() {
            //
        },
        async save() {
            if (this.loading) return;

            this.loading = true;
            try {
                this.validates();

                let { post, put } = api.console.inquiries;
                let inquiry = (await (this.isCreate ? post : put)(this.form))?.inquiry;

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", inquiry);
                this.dialog = false;
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
